import { render, staticRenderFns } from "./approvalSend.vue?vue&type=template&id=b8bf38ae"
import script from "./approvalSend.vue?vue&type=script&lang=js"
export * from "./approvalSend.vue?vue&type=script&lang=js"
import style0 from "./approvalSend.vue?vue&type=style&index=0&id=b8bf38ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports